/** Keeps the document title and share cards in step with client-side routing. */

interface PageMeta {
  title: string;
  ogTitle: string;
  description: string;
}

const DEFAULT_META: PageMeta = {
  title: "josh hammer",
  ogTitle: "josh hammer",
  description:
    "Interactive terminal homepage with a multiplayer grappling game and experimental chron & duod time systems.",
};

const PAGES: Record<string, PageMeta> = {
  "/grapple": {
    title: "grapple",
    ogTitle: "grapple — multiplayer grappling arena",
    description:
      "Drop straight into a fast, physicsy multiplayer grappling-hook arena inside josh hammer's terminal homepage.",
  },
  "/chron": {
    title: "chron",
    ogTitle: "chron — metric time clock",
    description:
      "Explore metric time with a live chron clock and converters between chrons and conventional hours, minutes, and seconds.",
  },
  "/duod": {
    title: "duod",
    ogTitle: "duod — duodecimal time",
    description:
      "Play with duodecimal time, Primel units, and converters between dozenal day fractions and HH:MM:SS.",
  },
  "/wot": {
    title: "the eye of the world",
    ogTitle: "the eye of the world — a reader survey",
    description:
      "What a handful of friends thought of The Eye of the World, answered in numbers and charted as they come in.",
  },
  "/ttt": {
    title: "three·cubed",
    ogTitle: "three·cubed — 3D noughts and crosses for two",
    description:
      "Noughts and crosses in a 3x3x3 lattice, for two players over a link. The true centre is sealed and the opening move cannot be a corner.",
  },
};

function metaFor(path: string): PageMeta {
  if (PAGES[path]) return PAGES[path];
  if (path.startsWith("/chron/")) return PAGES["/chron"]!;
  if (path.startsWith("/duod/")) return PAGES["/duod"]!;
  // The trailing-slash forms the server also serves.
  const trimmed = path.length > 1 && path.endsWith("/") ? path.slice(0, -1) : path;
  if (PAGES[trimmed]) return PAGES[trimmed];
  return DEFAULT_META;
}

export function applyMeta(path: string): void {
  const meta = metaFor(path);
  document.title = meta.title;

  setContent("meta-og-title", meta.ogTitle);
  setContent("meta-og-description", meta.description);
  setContent("meta-twitter-title", meta.ogTitle);
  setContent("meta-twitter-description", meta.description);
}

function setContent(id: string, value: string): void {
  document.getElementById(id)?.setAttribute("content", value);
}

/** Pushes a new path only when it actually changes, and updates the meta. */
export function navigate(path: string): void {
  if (window.location.pathname !== path) history.pushState(null, "", path);
  applyMeta(path);
}
